module.exports = __webpack_public_path__ + "static/media/my-account-personal-info.1ce123f8.svg";